<div class="container section__docs h-full">
  <div class="wrapper wrapper--extend">
    <div class="sectionContainer fadeinright animation-duration-300">
      <article>
        <div class="mainInfo mainInfo--maxWidthExtend">
          <h1>Autorización de reportes de crédito</h1>
        </div>

        <div class="legals pt-30">
          <p>Señores CREDIYA, S.A., Ciudad de Panamá</p>

          <p>
            Estimados señores: Por este medio autorizo(amos) expresamente a la <strong>FINANCIERA</strong> sus subsidiarias y/o afiliadas, cesionarios o sucesoras, así como cualquier compañía que por operación de cesión, administración o compra de cartera adquiera los derechos de mi crédito, a que de conformidad con lo expresado en el artículo 24 y demás disposiciones aplicables de la Ley 24 de 22 de mayo de 2002, solicite, consulte, recopile, intercambie y transmita a cualquier agencia de información de datos, bancos o agentes económicos de la localidad, sobre mi (nuestros) historial de crédito y relaciones con acreedores.
          </p>

          <p>
            <strong>También queda facultada la FINANCIERA, sus subsidiarias y/o afiliadas, cesionarios o sucesoras, así como cualquier compañía que por una operación de cesión, administración o compra de cartera adquiera los derechos de mi crédito, a que solicite y obtenga información de instituciones gubernamentales relacionadas con las obligaciones o transacciones crediticias arriba referidas.</strong>
          </p>

          <p>
            Asimismo, exonero (amos) de cualquier consecuencia o responsabilidad resultante del ejercicio de solicitar o suministrar información, o por razón de cualesquiera autorizaciones contenidas en la presente carta, a la FINANCIERA, a sus compañías afiliadas, subsidiarias, cesionarios y/o sucesoras, a sus empleados, ejecutivos, directores dignatarios o apoderados, así como cualquier compañía que por una operación de cesión, administración o compra de cartera adquiera los derechos de mi crédito. 
          </p>
        </div>
      </article>
    </div>
  </div>
</div>